import { Environment } from '../../models/environment.type';

export class SetupService {
  public static localApiStorageKey = 'apiUrl';
  public static setupPageDomains =
    /\.norsefb\.pages\.dev|\.norse-feature-branches\.pages\.dev|\.dev-norse\.com|localhost/i;

  static get overrideEnvironment(): Partial<Environment> {
    const override: Partial<Environment> = {};
    try {
      if (
        window.location.host.match(this.setupPageDomains)
      ) {
        const baseUrlFromLocalStorage = JSON.parse(
          localStorage.getItem(this.localApiStorageKey) || '""',
        ) as string;
        if (baseUrlFromLocalStorage && new URL(baseUrlFromLocalStorage)) {
          override.apiBaseUrl = baseUrlFromLocalStorage;
          override.cmsBaseUrl = `${baseUrlFromLocalStorage}v1/cms/`;

          if(baseUrlFromLocalStorage.indexOf('services.uat-norse')>=0){
              override.apiPaymentsUrl= 'https://payment-api.uat-norse.com/api/'
          }
          else{
            override.apiPaymentsUrl= 'https://payment-api.dev-norse.com/api/'
          }
    
        }
      } else {
        localStorage.removeItem(this.localApiStorageKey);
      }
    } catch {
      /* Ignore */
    }
    return override;
  }
}
